;(function () {
  'use strict'

  angular
    .module('contrast.application.dashboard')
    .factory('AppTagModalService', AppTagModalService)

  function AppTagModalService($q, ErrorService, TagFactory, logger) {
    'ngInject'

    return {
      init: init,
      save: save,
      hasAvailableTags: hasAvailableTags
    }

    function init(appsId, $scope, originalTags) {
      var promises = []

      var scopeAvailableTags = []
      var originalAppTags = []
      var scopeModelTags = []
      var scopeHasTags = false
      var scopeBulkOperation = false

      promises.push(TagFactory.getApplicationsTags())
      promises.push(TagFactory.getApplicationsTagsBulk(appsId))

      return $q
        .all(promises)
        .then(function (results) {
          scopeAvailableTags = results[0].data.tags

          if (results[1].data.tags) {
            originalAppTags = results[1].data.tags
            scopeModelTags = results[1].data.tags
            scopeHasTags = originalTags.length > 0
            scopeBulkOperation = $scope.has_tags && appsId.length > 1
          }

          return {
            scopeAvailableTags,
            originalAppTags,
            scopeModelTags,
            scopeHasTags,
            scopeBulkOperation
          }
        })
        .catch(_processError)
    }

    function save(originalTags, $scope, appsId, $uibModalInstance) {
      TagFactory.tagApplicationsBulk(
        tagRequest(originalTags, $scope, appsId)
      ).then(function (response) {
        var data = response.data
        logger.logSuccess(data.messages[0])
        $uibModalInstance.close()
      }, _processError)
    }

    function _processError(response) {
      ErrorService.processError(response)
      $uibModalInstance.close()
    }

    function tagRequest(originalTags, $scope, appsId) {
      var tagsRemove = _.difference(originalTags, $scope.model.tags)
      return {
        applications_id: appsId,
        tags: $scope.model.tags,
        tags_remove: tagsRemove
      }
    }

    function hasAvailableTags($scope) {
      return (
        !$scope.model.tags &&
        $scope.model.tags &&
        $scope.model.tags.length == 0 &&
        $scope.availableTags &&
        $scope.availableTags.length == 0
      )
    }
  }
})()
